// src/components/FooterBar.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import {
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaWhatsapp,
  FaShareAlt,
} from "react-icons/fa";

const SHARE_DOMAIN = "https://www.bolbalatv.com"; // base public domain

const FooterBar = () => {
  const location = useLocation();
  const isStoryPage = location.pathname.startsWith("/story/");

  // extract slug from /story/:slug
  const slug = isStoryPage
    ? decodeURIComponent(location.pathname.split("/")[2] || "")
    : "";

  const handleShare = async () => {
    // default: current URL
    let shareUrl = window.location.href;

    // 1️⃣ on story page -> use HTML/slug.html
    if (isStoryPage && slug) {
      shareUrl = `${SHARE_DOMAIN}/HTML/${slug}.html`;
    }

    const shareTitle = document.title || "Bolbala TV";
    const shareText = isStoryPage
      ? `ही बातमी बघा:\n${shareTitle}`
      : "ही लिंक बघा:";

    // Native share if available
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl,
        });
        return;
      } catch (err) {
        console.log("Share aborted", err);
        // fall through to clipboard
      }
    }

    // Fallback: copy URL
    try {
      await navigator.clipboard.writeText(shareUrl);
      alert("लिंक कॉपी केली आहे.");
    } catch {
      alert("लिंक कॉपी मध्ये अडचण आली.");
    }
  };

  return (
    <footer className="footer-bar-pro">
      {/* Left icons */}
      <div className="footer-icons-row">
        <a href="mailto:bolbalamedia@gmail.com">
          <FaEnvelope className="footer-icon-large" />
        </a>

        <a href="https://wa.me/+9190967200999" target="_blank" rel="noreferrer">
          <FaWhatsapp className="footer-icon-large" />
        </a>
      </div>

      {/* Center Share button */}
      <button className="footer-share-btn-pro" onClick={handleShare}>
        <FaShareAlt />
      </button>

      {/* Right icons */}
      <div className="footer-icons-row">
        <a
          href="https://www.instagram.com/bolbalatv"
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram className="footer-icon-large" />
        </a>

        <a
          href="https://youtube.com/@bolbalamedia"
          target="_blank"
          rel="noreferrer"
        >
          <FaYoutube className="footer-icon-large" />
        </a>
      </div>
    </footer>
  );
};

export default FooterBar;
